import OrderSelect from './OrderSelect'
import reservationTypes from './reservationTypes'
import { userEmailHydrator } from '../../../fieldOptions/hydrators'

const typeOptions = [{
  value: reservationTypes.user,
  name: 'User'
}, {
  value: reservationTypes.institution,
  name: 'Institution'
}]

const isFspOrGeneric = sessionSale => ['fsp', 'generic'].includes(sessionSale.type)

export default sessionSale => [
  {
    name: 'Type',
    prop: 'type',
    type: 'select',
    options: typeOptions
  }, {
    name: 'User',
    prop: 'user_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    dataHydrator: userEmailHydrator,
    displayProp: 'displayVal',
    showIf: resource => resource.type === reservationTypes.user
  },
  {
    name: 'Institution',
    prop: 'institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name',
    showIf: resource => resource.type === reservationTypes.institution
  },
  {
    name: 'Order',
    prop: 'order_id',
    type: 'component',
    component: OrderSelect,
    componentProps: { sessionSaleId: sessionSale.id },
    showIf: resource => {
      return isFspOrGeneric(sessionSale) && !!resource.type
    }
  }
]
